'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _utils = require('../../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var getOrDefault = _utils.FormattingUtils.getOrDefault;

var ApplicationFields = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(ApplicationFields, _Component);

  function ApplicationFields() {
    _classCallCheck(this, ApplicationFields);

    return _possibleConstructorReturn(this, (ApplicationFields.__proto__ || Object.getPrototypeOf(ApplicationFields)).apply(this, arguments));
  }

  _createClass(ApplicationFields, [{
    key: 'renderRow',
    value: function renderRow(field) {
      var label = field.label,
          value = field.value,
          Component = field.Component,
          formatter = field.formatter,
          lineWrap = field.lineWrap,
          classNames = (0, _classnames2.default)('col-value', { 'ellipsis': !lineWrap });


      if (Component) {
        return _react2.default.createElement(Component, _extends({
          key: label
        }, this.props, field));
      }

      var formattedValue = formatter ? formatter(value) : value;

      return _react2.default.createElement(
        _Col2.default,
        { key: label, xs: 6 },
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _Col2.default,
            { className: 'col-label', xs: 4 },
            getOrDefault(label)
          ),
          _react2.default.createElement(
            _Col2.default,
            { className: classNames, xs: 8 },
            getOrDefault(formattedValue)
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var fields = this.props.fields;


      return _react2.default.createElement(
        _Row2.default,
        { className: 'info-well' },
        fields.map(this.renderRow)
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return ApplicationFields;
}(_react.Component), _class2.propTypes = {
  _case: _propTypes2.default.object,
  application: _propTypes2.default.object,
  fields: _propTypes2.default.array.isRequired,
  onCaseApplicationChanged: _propTypes2.default.func
}, _temp)) || _class) || _class;

var _default = ApplicationFields;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(getOrDefault, 'getOrDefault', '/app/src/components/page-case/main-applications/ApplicationFields.js');
  reactHotLoader.register(ApplicationFields, 'ApplicationFields', '/app/src/components/page-case/main-applications/ApplicationFields.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-applications/ApplicationFields.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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